export default "__VITE_ASSET__CcUOwG2a__"